import BookingTable from '../components/dashboard/BookingTable'
import StatisticSummary from '../components/dashboard/StatisticSummary'
import Toolbar from '../components/dashboard/Toolbar'

import { useDashboard } from '@/hooks/useDashboard'

const Dashboard = () => {
  const { showStatistics } = useDashboard()

  return (
    <div className="flex h-full flex-col gap-4 p-4">
      {/* Toolbar Section - Sticky at top */}
      <div className="shrink-0">
        <Toolbar />
      </div>

      {/* Statistics Section */}
      {showStatistics && (
        <div className="shrink-0">
          <StatisticSummary />
        </div>
      )}

      {/* Table Section - Scrollable */}
      <div className="grow overflow-auto">
        <BookingTable />
      </div>
    </div>
  )
}

export default Dashboard
